<footer class="footer" *ngIf="footerData">
  <div class="footer-container">
    <!------- Links ------->
    <div class="footer-links-container">
      <div *ngFor="let cols of footerData?.columns">
        <nav *ngFor="let reference of cols.fields.footerSubsectionReferences">
          <p class="footer-links-heading">
            <span *ngIf="!reference?.fields?.footerHyperLinkAction" class="no-link">{{reference.fields.subSectionTitle}}</span>
            <a *ngIf="reference?.fields?.footerHyperLinkAction" 
              class="footer-heading-link" 
              href="{{reference?.fields?.footerHyperLink | urlParams:queryParams}}" 
              target="{{reference?.fields?.footerHyperLinkAction}}"
              (click)="onFooterLinkClick(reference.fields.subSectionTitle, reference.fields.subSectionTitle, reference?.fields?.footerHyperLink)">
              {{reference.fields.subSectionTitle}}
            </a>
          </p>
          <ul class="footer-nav">
            <ng-container *ngFor="let link of reference.fields.linkedPagesReferences" >
              <li *ngIf="link.fields.title">
                <a class="footer-link" 
                  href="{{link.fields.hyperLinks | urlParams:queryParams}}" target="{{link.fields.actionType}}"
                  (click)="onFooterLinkClick(reference.fields.subSectionTitle, link.fields.title, link.fields.hyperLinks)">
                  {{link.fields.title}}
                  <span *ngIf="link.fields.title === 'Card Issuing API'" class="badge-style">Coming soon</span>
                </a>
              </li>
            </ng-container>
          </ul>
        </nav>
      </div>
    </div>
    <!------- Social ------->
    <div class="footer-social">
      <a class="social-icon" href="{{footerData.logo.link}}"><img loading="lazy" src="{{footerData.logo.url}}" alt="{{footerData.logo.alt}}" /></a>
      <ul class="footer-social-links">
        <li *ngFor="let link of footerData.socialLinks">
          <a class="social-icon" href="{{link.fields.hyperLinks | urlParams:queryParams}}" target="{{link.fields.actionType}}"
             (click)="onSocialClick(link.fields.icon.fields.title, link.fields.hyperLinks)">
            <img loading="lazy" src="{{link.fields.icon.fields.file.url}}" alt="{{link.fields.icon.fields.title}}" class="footer-social-icon" >
          </a>
        </li>
      </ul>
    </div>
    <div class="separator"></div>
    <!------- Terms ------->
    <div class="footer-terms-container">
      <div [innerHtml]="footerData?.paragraph | toHtml"></div>
      <div class="pink-800">
        {{footerData.note}}
      </div>
      <div class="display-f security-compliance-logo">
        <img *ngFor="let img of footerData.securityCompliance" loading="lazy" src="{{img.fields.file.url}}" alt="{{img.fields.title}}" />
      </div>
      <div class="copyright">
        <span>&copy;{{footerData.copyright}}</span>
        <div class="reserved-text" [innerHtml]="footerData.reserved | toHtml"></div>
      </div>
    </div>
  </div>
</footer>